module.exports = __webpack_public_path__ + "img/instagram.d98058af.svg";